module.exports = {
    "Clear search": `Keres\xe9s t\xf6rl\xe9se`
};


//# sourceMappingURL=hu-HU.main.js.map
